import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[700px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold mb-3">
              联络我们
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              {contactData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[560px] mx-auto">
              {contactData.description}
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</div>
                  <a href={`mailto:${contactData.email}`} className="text-sm text-primary-500 hover:text-primary-600 transition-colors no-underline">
                    {contactData.email}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-accent-500 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900 mb-1">微信联系</div>
                  <div className="text-sm text-foreground-600">{contactData.wechat}</div>
                </div>
              </div>
            </div>

            <div className="mt-6 pt-5 border-t border-background-200/70 text-center">
              <div className="flex items-center justify-center gap-2 text-xs text-foreground-500">
                <i className="ri-time-line"></i>
                <span>{contactData.tips}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}